import { FormHelperText, MenuItem, Select, TextField } from "@material-ui/core";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useForm, useFormState } from "react-final-form";

import classNames from "classnames";
import { get } from "lodash";
import { useDebounce } from "ra-friendsofbabba";
import { useTranslate } from "react-admin";

const EvalRowInput = ({
  config,
  disabled,
  source,
  classes,
  subCategory = undefined,
  subCategoryParam = undefined,
}) => {
  if (!subCategory && !subCategoryParam) {
    throw new Error(
      "EvalRowInput: subCategory or subCategoryParam must be provided"
    );
  }
  const form = useForm();
  const formState = useFormState();
  const translate = useTranslate();
  const { value, notes, validationError } = useMemo(() => {
    const filledItems = get(formState.values, source, []);
    const target = filledItems.find((fi) =>
      subCategoryParam
        ? fi.eval_sub_category_param_id === subCategoryParam.id
        : fi.eval_sub_category_id === subCategory.id
    );
    const index = filledItems.indexOf(target);
    let id = get(target, "eval_judgment_id", 0);
    let notes = get(target, "notes", "");

    if (id === null) {
      id = 0;
    }
    if (notes === null) {
      notes = "";
    }
    const submitError = get(formState.submitErrors, source);

    const validationError = get(submitError, `${index}.eval_judgment_id`);

    return { value: id, notes, validationError };
  }, [formState, subCategory, subCategoryParam, source]);
  const [id, setId] = useState(value);
  const [text, setText] = useState(notes);
  const debouncedId = useDebounce(id, 50);
  const debouncedNotes = useDebounce(text, 3000);
  const handleChange = useCallback((e) => setId(e.target.value), []);
  const handleTextChange = useCallback((e) => setText(e.target.value), []);

  const didMount = useRef(false);
  useEffect(
    () => {
      if (didMount.current === false) {
        didMount.current = true;
        return;
      }
      const filledItems = get(formState.values, source, []);
      const target = filledItems.find((fi) =>
        subCategoryParam
          ? fi.eval_sub_category_param_id === subCategoryParam.id
          : fi.eval_sub_category_id === subCategory.id
      );
      target.eval_judgment_id = debouncedId > 0 ? debouncedId : null;
      target.notes = debouncedNotes;
      form.change(source, [...filledItems]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedId, debouncedNotes]
  );
  return (
    <Fragment>
      <Select
        className={classNames(
          classes.paramSelect,
          subCategory.id >= 21 && classes.paramSelectTwoLines
        )}
        fullWidth
        disabled={disabled}
        variant="filled"
        value={value}
        onChange={handleChange}
      >
        <MenuItem value={0}></MenuItem>
        {config.eval_judgments.map((ej) => (
          <MenuItem key={ej.id} id={ej.id} value={ej.id}>
            {ej.name}
          </MenuItem>
        ))}
      </Select>

      {validationError && (
        <FormHelperText error>{validationError}</FormHelperText>
      )}
      <TextField
        value={text}
        fullWidth
        variant="filled"
        multiline
        className={classes.notes}
        onChange={handleTextChange}
        label={translate("resources.research-project-eval-items.fields.notes")}
        disabled={disabled}
      />
    </Fragment>
  );
};

export default EvalRowInput;
